import { connect } from 'react-redux';

import * as Actions from 'store/analytics/actions';

import AnalyticsPerformance from './AnalyticsPerformance';

const mapStateToProps = (state) => ({
  performanceCharts: state.analytics.performanceCharts,
  performanceStatics: state.analytics.performanceStatics,
  performanceOverviews: state.analytics.performanceOverviews,
  performanceChartsLoading: state.analytics.performanceChartsLoading,
  performanceStaticsLoading: state.analytics.performanceStaticsLoading,
  performanceOverviewsLoading: state.analytics.performanceOverviewsLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getPerformanceCharts: (payload) => dispatch(Actions.getPerformanceCharts(payload)),
  getPerformanceStatics: (payload) => dispatch(Actions.getPerformanceStatics(payload)),
  getPerformanceOverviews: (payload) => dispatch(Actions.getPerformanceOverviews(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AnalyticsPerformance);
